require([],
    function () {       
        
        var thePdf = null;
        var scale = 1.5;
        var pdfjsLib = window['pdfjs-dist/build/pdf'];
        pdfjsLib.GlobalWorkerOptions.workerSrc = '/scripts/thirdParty/pdfjs/pdf.worker.js';       
       
        function init() {   
            document.title = title;
            var loadingTask = pdfjsLib.getDocument(url);

            loadingTask.onProgress = function (data) {              
                var percent_loaded = Math.round((data.loaded / data.total) * 100);
                refreshProgressBar(percent_loaded);                
            }

            loadingTask.promise.then(function (pdf) {
                thePdf = pdf;
                viewer = document.getElementById('pdf-viewer');

                for (page = 1; page <= pdf.numPages; page++) {
                    canvas = document.createElement("canvas");
                    canvas.className = 'pdf-page-canvas';
                    viewer.appendChild(canvas);
                    renderPage(page, canvas);
                }
            });
        }

        function refreshProgressBar(width) {    
            var pdfProgressBarValue = document.getElementById("pdfProgressBarValue");            
            var pdfBar = document.getElementById("pdfBar");
            var value = width + "%";
            if (width >= 100) {      
                value = "100%";
                var pdfProgressBar = document.getElementById("pdfProgressBar");
                pdfBar.style.width = value;
                pdfProgressBarValue.textContent = value;                
                pdfProgressBar.style.display = 'none';    
                var loadingText = document.getElementById("loadingText");
                loadingText.style.display = 'none';    
            } else {
                pdfBar.style.width = value;
                pdfProgressBarValue.textContent = value;
            }
        }

        goBack = function () {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                window.close();
            }
        }

        function renderPage(pageNumber, canvas) {
            thePdf.getPage(pageNumber).then(function (page) {
                var viewport = page.getViewport({ scale: scale });
                canvas.height = viewport.height;
                canvas.width = viewport.width;
                page.render({ canvasContext: canvas.getContext('2d'), viewport: viewport });
            });
        }

        init();
    });
define("PdfViewer/main", function(){});

